import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageMeta = (title, description) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://hotelrespiro.com${pathname === '/' ? '/' : pathname}`);
    }
  }, [title, description, pathname]);
};

export default usePageMeta;
